import { c as _c } from "react/compiler-runtime";
import { Stack } from '@mui/material';
import type { ReactNode } from 'react';
import { SearchTextBox } from '@/components/search/searchTextBox';
import { type TagFilterMode } from './tagKeyValueUtils';

/**
 * The search row of a tags filter: one box per half of the tag the mode selects, plus an optional
 * trailing action. Only the two-box key-value mode needs to say which box is which.
 */
export const TagSearchBoxes = t0 => {
  const $ = _c(16);
  const {
    mode,
    keyFilter,
    valueFilter,
    onKeyFilterChange,
    onValueFilterChange,
    action
  } = t0;
  const hasValueSearch = mode === "key-value";
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      alignItems: "center",
      gap: "12px"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      gap: "12px",
      flexGrow: 1
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = hasValueSearch ? "Search by key" : "Search...";
  let t4;
  if ($[2] !== keyFilter || $[3] !== onKeyFilterChange || $[4] !== t3) {
    t4 = <SearchTextBox value={keyFilter} onChange={onKeyFilterChange} placeholder={t3} />;
    $[2] = keyFilter;
    $[3] = onKeyFilterChange;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== hasValueSearch || $[7] !== onValueFilterChange || $[8] !== valueFilter) {
    t5 = hasValueSearch && <SearchTextBox value={valueFilter} onChange={onValueFilterChange} placeholder="Search by value" />;
    $[6] = hasValueSearch;
    $[7] = onValueFilterChange;
    $[8] = valueFilter;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t4 || $[11] !== t5) {
    t6 = <Stack sx={t2}>{t4}{t5}</Stack>;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== action || $[14] !== t6) {
    t7 = <Stack direction="row" className="w-full" sx={t1}>{t6}{action}</Stack>;
    $[13] = action;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
};